document.addEventListener("DOMContentLoaded", function() {
  // OVERLAY
  const raoOverlay = document.querySelector(".rao-overlay");
  if(raoOverlay) {
    const closeBtn = raoOverlay.querySelector("svg");
    closeBtn.addEventListener("click", function() {
      raoOverlay.classList.remove("open");
    });

    raoOverlay.addEventListener("click", function(e) {
      console.log(e.target);
      if(!raoOverlay.querySelector(".rao-overlay--content").contains(e.target)) {
        raoOverlay.classList.remove("open");
      }
    });
  }

  // UPSELL PRODUCTS
  const container = document.querySelector(".product-info--upsell-products");

  if(container) {
    const products = container.querySelectorAll(".product-info--upsell-products__product");
    const button = document.querySelector('buy-buttons a.button');
    const form = document.querySelector(".shopify-product-form");

    const accordionBtn = container.querySelector(".product-info--upsell-products__button");

    if(accordionBtn) {
      const content = container.querySelector(".product-info--upsell-products__content");
      const inner = container.querySelector(".product-info--upsell-products__products");

      content.style.setProperty("--content-height-amount", `${content.getBoundingClientRect().height}px`);
      inner.classList.add("show");
      content.style.setProperty("--inner-height-amount", `${inner.getBoundingClientRect().height + 20}px`);

      accordionBtn.addEventListener("click", function() {
        container.classList.toggle("open");
      });
    }

    if(button) {
      button.addEventListener("click", async function(e) {
        e.preventDefault();
        await form.add();
      });
    }

    for(const product of products) {
      const infoBtn = product.querySelector(".product-info--upsell-products__info svg");
      if(infoBtn) {
        const overlay = document.querySelector(".rao-overlay");
        infoBtn.addEventListener("click", function() {
          overlay.querySelector(".rao-overlay--inner").innerHTML = product.querySelector(".product-info--upsell-products__info img").outerHTML;
          overlay.classList.add("open");
        });
      }

      const checkbox = product.querySelector(".product-info--upsell-products__checkbox");
      checkbox.addEventListener("click", function() {
        checkbox.classList.toggle("selected");
      });
    }
  }
});